import { createAction } from "@reduxjs/toolkit";

export const playSound = createAction(
  "audio/play-sound",
  (audioId: string, getHandler: boolean = false) => ({
    payload: {
      audioId,
      getHandler,
    },
  }),
);
